/**
 * Type guard to check if a value is defined.
 *
 * @example
 * ```ts
 * isDefined(1); // true
 * isDefined(0); // true
 * isDefined(undefined); // false
 * isDefined(null); // false
 * ```
 */
export function isDefined<T>(value: T): value is NonNullable<T> {
  return value !== null && value !== undefined;
}
